export default function Services() {
  const services = [
    {
      icon: 'ri-shield-keyhole-line',
      title: 'Secure VPN',
      description: 'Military-grade encryption protecting your online activities with zero-log policy and complete anonymity across all your devices',
      image: 'https://public.readdy.ai/ai/img_res/9b4f3dd2f3c64be9e8fafe8f966d973a.jpg'
    },
    {
      icon: 'ri-code-box-line',
      title: 'Custom Applications',
      description: 'Tailored software solutions designed to meet your specific business needs with cutting-edge technology and seamless integration',
      image: 'https://readdy.ai/api/search-image?query=Clean%203D%20rendered%20smartphone%20mockup%20displaying%20modern%20minimalist%20app%20interface%20with%20teal%20accent%20colors%2C%20floating%20with%20soft%20shadow%20on%20pure%20white%20background%2C%20professional%20product%20visualization%20showing%20sleek%20mobile%20application%20design&width=600&height=400&seq=service-app-001&orientation=squarish'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Performance Tools',
      description: 'Advanced system optimization utilities that enhance device performance, clean unnecessary files, and boost overall efficiency',
      image: 'https://readdy.ai/api/search-image?query=Abstract%203D%20visualization%20of%20system%20performance%20optimization%20with%20animated%20speed%20indicators%20and%20progress%20bars%2C%20vibrant%20orange%20to%20pink%20gradient%20colors%2C%20modern%20tech%20aesthetic%20showing%20performance%20metrics%20on%20clean%20white%20background&width=600&height=400&seq=service-perf-001&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 gap-8">
          <div>
            <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">What We Offer</p>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900">Complete Digital<br />Protection</h2>
          </div>
          <p className="text-gray-600 leading-relaxed max-w-xl">
            We provide comprehensive security solutions and innovative applications designed to protect your digital life while enhancing your online experience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-white to-gray-50 rounded-3xl p-8 hover:shadow-2xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-full h-48 mb-6 rounded-2xl overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="w-14 h-14 flex items-center justify-center mb-4">
                <i className={`${service.icon} text-4xl text-teal-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
